import {AnswersStats, MatrixQuestionStats, MatrixStats} from 'common/models/success';

export const isMatrixStats = (stats: AnswersStats | MatrixStats): stats is AnswersStats => {
    return Object.keys(stats).every((key) => Array.isArray(stats[key]));
};

export const transformToStats = (matrixStats: MatrixQuestionStats[]) => {
    return matrixStats.reduce<AnswersStats>((acc, {label, count}) => {
        acc[label] = count;
        return acc;
    }, {});
};
